import React, {useCallback, useEffect, useRef, useState} from "react";
import axios from "../../utils/apiClient";
import {AppPropertiesUtil, SessionStorageUtil} from "../../utils/localStorageUtil";
import {getProperties} from "../constantsActions";
import {useAuth} from "../../context/authContext";
import {useDispatch} from "react-redux";
import {setUserEventAction} from "../manageVisitActions";
import {convertDateToString} from "../../utils/util";
import {saveReferral} from "../../views/quickList/components/modals/Referrals/context/referralsApi";
import {Spinner} from "react-bootstrap";

const isEmpty = require("is-empty");
const useCboDropdown = (clientId, patient) => {
  const [samlResponse, setSamlResponse] = useState({})
  const [communityUrl, setCommunityUrl] = useState({})
  const auth = useAuth();
  const userName = auth.getName();
  const globalDispatch = useDispatch();
  const patientId = patient?.id;
  const isMountedRef = useRef(true);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const initProperties = useCallback(async (org) => {
    let res = await getProperties();
    SessionStorageUtil.setObj("properties", res.data);
    if (res.data && isMountedRef.current) {
      setCommunityUrl(res.data[org])
    }
  }, [])

  const getUrls = useCallback(() => {
    const urlForFindHelp = AppPropertiesUtil.get("ce.saml.findhelp.subject-recipient");
    if (!urlForFindHelp) {
      initProperties("ce.saml.findhelp.subject-recipient")
    } else {
      if (isMountedRef.current) {
        setCommunityUrl(urlForFindHelp)
      }
    }
  }, [initProperties])

  const getSamlResponse = useCallback((thenTask) => {
    getUrls();
    let url = process.env.REACT_APP_REST_API_BASE_URL + "/v1/saml/";

    if (patientId && clientId) {
      url = `${url}response?patientId=${patientId}&clientId=${clientId}&type=REFERRAL&referredTo=FindHelp`
    } else {
      if (clientId) {
        url = `${url}response?patientId=&clientId=${clientId}&type=ADMIN&referredTo=FindHelp`
      } else{
        url = `${url}response?patientId=&clientId=AZEH&type=ADMIN&referredTo=FindHelp`
      } 
    }

    axios.get(url, {
      headers: {},
    }).then((response) => {
      if (isMountedRef.current) {
        thenTask(response);
      }
    }).catch(() => {   
    });
  }, [clientId, getUrls, patientId])

  const referComponent = useCallback(() => {
    const createReferral = () => {
      const visitExpirationDate = convertDateToString();
      const referral = {
        patientId,
        referrerName: userName,
        sentByFullName: userName,
        refDateUTC: new Date(Date.now()).toISOString(),
        status: "CBO_REFERRAL",
        referralType: "COMMUNITY_BASED_ORGANIZATION",
        visitExpirationDate,
        referredPractice: "",
        note: "Service Test",
        urgency: "CBO_REFERRAL",
        servicesNeeded: [
          {
            "service": "EXTERNAL_REFERRAL_TO_CBO",
            "primary": true
          }
        ],
        "diagnosisICD10dto": [
          {
            "code": "",
            "description": ""
          }
        ],

      }
      saveReferral(referral).then(() => {
        globalDispatch(setUserEventAction('REFERRAL_ADDED'))
      }).catch(error => {
      })
    }
    if (isEmpty(samlResponse)) {
      return <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
      />
    }
    return (

      <form
        method="post"
        action={communityUrl}
        target="_blank">
        <input type="textarea" name="SAMLResponse" hidden id="SAMLResponse" value={samlResponse.samlResponse} readOnly />
        <input type="text" hidden name="RelayState" value={samlResponse.relayState} readOnly />
        <button className="dropdown-item" onClick={createReferral} type="submit">Refer to Community-Based Organization (HRSN)</button>
      </form>
    );

  }, [communityUrl, globalDispatch, patientId, samlResponse, userName]);

  return [referComponent, getSamlResponse, setSamlResponse]
};

export default useCboDropdown;
